import { TextField } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { deleteUrlParams, setUrlParams } from 'libs/helper/paramsUtil';
import { Row, Button as SaladButton } from 'saladsoft-primitive';
import { getUrlParam } from 'libs/helper/utils';

const SearchBox = ({ paramKey, placeholder }: { paramKey: string; placeholder: string }) => {
  const handleReset = () => {
    if (inputRef.current) {
      inputRef.current.value = '';
      inputRef.current.querySelector('input').value = '';
    }
  };

  const inputRef = useRef<any>(null);
  const [searchKeyword, setSearchKeyword] = useState<string>('');
  const [isSearched, setIsSearched] = useState<boolean>(false);
  const keyword = useRef<string>('');

  useEffect(() => {
    const search = getUrlParam(paramKey);
    if (search) {
      setIsSearched(true);
      setSearchKeyword(search);
    } else {
      setIsSearched(false);
      setSearchKeyword('');
    }
  }, []);

  return (
    <div style={{ width: 350 }}>
      <Row width="100%" justifyContent="flex-start">
        <TextField
          ref={inputRef}
          placeholder={placeholder}
          value={searchKeyword}
          onChange={(e) => {
            setSearchKeyword(e.target.value);
            keyword.current = e.target.value;
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              setIsSearched(true);
              setUrlParams({
                [paramKey]: searchKeyword,
                page: '1',
              });
            }
          }}
          style={{ padding: 0 }}
        />
        <>
          {isSearched && (
            <SaladButton
              type="link"
              onClick={() => {
                handleReset();
                deleteUrlParams([paramKey]);
              }}
            >
              취소
            </SaladButton>
          )}
        </>
      </Row>
    </div>
  );
};

export default SearchBox;
